var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{ref:"_wrapper",attrs:{"id":"emulatorWrapper"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isStarted),expression:"isStarted"}],ref:"_container",attrs:{"id":"emulator-container"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }